function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
// DynamicLink.js
const DynamicLink = (props)=>{
    const { href, children } = props, rest = _object_without_properties(props, [
        "href",
        "children"
    ]);
    // Attempt to dynamically import the Next.js Link component
    const [LinkComponent, setLinkComponent] = React.useState(null);
    React.useEffect(()=>{
        let isMounted = true;
        // Dynamically import the Next.js Link component if Next.js is detected
        // apparently have to cast this to update to "moduleResolution": "NodeNext"
        import("next/link").then((NextLink)=>{
            if (isMounted) {
                setLinkComponent(()=>NextLink.default);
            }
        }).catch((e)=>{
            // If the import fails, we assume we're not in a Next.js environment
            setLinkComponent(null);
        });
        return ()=>{
            isMounted = false;
        };
    }, []);
    // If LinkComponent is loaded, render it. Otherwise, fall back to a regular <a> tag.
    if (LinkComponent) {
        return /*#__PURE__*/ _jsx(LinkComponent, {
            href: href,
            legacyBehavior: true,
            children: /*#__PURE__*/ _jsx("a", _object_spread_props(_object_spread({}, rest), {
                children: children
            }))
        });
    } else {
        return /*#__PURE__*/ _jsx("a", _object_spread_props(_object_spread({
            href: typeof href === "string" ? href : href.href
        }, rest), {
            children: children
        }));
    }
};
export { DynamicLink };
